import React from "react";

const Footer = () => {
  return (
    <div className="bg-gray-800 px-10 sm:px-20 py-10">
      <div className="text-white grid gap-10 grid-cols-1 grid-rows-2 sm:grid-cols-2 sm:grid-rows-1">
        <div>
          <strong className="text-red-600 text-2xl">Locations</strong>
          <p className="text-lg">PartsBadger – HQ</p>
          <p>W66N205 Commerce Ct.</p>
          <p>Cedarburg, WI 53012</p>
          <div className="mt-4">
            <p className="text-lg">PartsBadger – Production</p>
            <p>W66N205 Commerce Ct.</p>
            <p>Cedarburg, WI 53012</p>
          </div>
        </div>
        <div>
          <strong className="text-red-600 text-2xl">Contact Us</strong>
          <p>
            <strong>Phone:</strong>&nbsp;331-BADGER-8
          </p>
          <p>(331) 223-4378</p>
          <p>8am-5pm CST M-F</p>
          <br/>
          <span className="text-red-600 italic">sales@parts-badger.com</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
